import React from 'react';
import FAQHeader from './FAQHeader';
import st from './style.module.scss';
import FAQInstructionSection from './FAQInstructionSection';
import FAQSection from './FAQSection';

const FaqForEmployees = () => {
  const type = 'employees';
  // const url = 'https://www.youtube.com/embed/LXb3EKWsInQ';
  return (
    <div className={st.faqContainer}>
      <FAQHeader type={type} />
      <FAQInstructionSection type={type} />
      {/*<VideoSection url={url} />*/}
      <FAQSection type={type} />
    </div>
  );
};

export default FaqForEmployees;
